
import React, { useState } from 'react';
import { Printer, MessageCircle, Info } from 'lucide-react';
import { Sale } from '../services/saleService';

interface TicketOptionsModalProps {
    sale: Sale;
    onPrint: (phone: string) => void;
    onWhatsApp: (phone: string) => void;
    onClose: () => void;
}

export const TicketOptionsModal: React.FC<TicketOptionsModalProps> = ({ sale, onPrint, onWhatsApp, onClose }) => {
    const [phone, setPhone] = useState(() => {
        const rawPhone = sale.customerPhone || '';
        // Si ya empieza con + o tiene longitud suficiente, lo respetamos
        if (rawPhone.startsWith('+')) return rawPhone;
        if (rawPhone.length > 0) return rawPhone; // Si ya venía sin + pero con datos, user lo editará o es local
        return '';
    });

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4" onClick={onClose}>
            <div className="bg-white rounded-xl shadow-2xl max-w-sm w-full p-6 text-center" onClick={(e) => e.stopPropagation()}>
                <div className="mb-4 flex flex-col items-center">
                    <div className="p-4 bg-green-100 rounded-full mb-4">
                        <div className="text-green-600 font-bold text-3xl">✓</div>
                    </div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-2">Venta Completada</h2>
                    <p className="text-gray-600 font-medium">Ticket #{sale.id}</p>
                    <p className="text-sm text-gray-500 mt-1">Total: ${sale.total.toFixed(2)}</p>
                </div>

                <p className="text-gray-600 mb-4">
                    Confirma el número de teléfono para el servicio y el recibo:
                </p>

                <div className="mb-6">
                    <div className="flex items-center justify-between mb-1">
                        <label className="block text-sm font-medium text-gray-700 text-left">Teléfono del Cliente</label>
                        <div className="group relative flex items-center">
                            <Info size={16} className="text-blue-500 cursor-help" />
                            <div className="absolute right-0 bottom-full mb-2 hidden group-hover:block w-48 p-2 bg-gray-800 text-white text-xs rounded shadow-lg z-10">
                                Este número se usará para enviar el recibo y actualizaciones del estado de la prenda.
                            </div>
                        </div>
                    </div>
                    <div className="relative">
                        <input
                            type="text"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            placeholder="Número de teléfono"
                        />
                    </div>
                </div>

                <div className="space-y-3">
                    <button
                        onClick={() => onPrint(phone)}
                        className="w-full flex items-center justify-center gap-3 py-3 bg-blue-600 text-white rounded-lg font-bold hover:bg-blue-700 transition"
                    >
                        <Printer size={20} />
                        Imprimir Ticket
                    </button>

                    <button
                        onClick={() => onWhatsApp(phone)}
                        disabled={!phone}
                        className={`w-full flex items-center justify-center gap-3 py-3 rounded-lg font-bold transition ${phone
                            ? 'bg-green-500 text-white hover:bg-green-600'
                            : 'bg-gray-200 text-gray-500 cursor-not-allowed'
                            }`}
                    >
                        <MessageCircle size={20} />
                        Enviar por WhatsApp
                    </button>

                    <button
                        onClick={onClose}
                        className="w-full py-2 text-gray-500 hover:text-gray-700 font-medium mt-2"
                    >
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
};
